import { IProductDataV2, Product } from '@df/catalog/product/product';
import { ProductListing as CoreProductListing } from '@df/catalog-ui/listing/product-listing';
import { EProductPhase, LocalProduct } from '../../model/product/product.decorator';
import { EStockOption, IN_STOCK_FILTER_ID } from './filter/stock/filter-stock';
import { IFilterDefinition, TAttrOptionSelection } from '@df/catalog-ui/listing/listing';
import { Filter } from '@df/catalog-ui/listing/filter/filter';
export class ProductListing<T extends Product = Product<IProductDataV2>> extends CoreProductListing<T> {
    protected override createFilter(filterDef: IFilterDefinition): void {
        if (filterDef.source === IN_STOCK_FILTER_ID) {
            filterDef.type = 'stock';
        }
        super.createFilter(filterDef);
    }

    override postFilterCheck(models: T[], selection: TAttrOptionSelection, overrides?: { filter: Filter<T>; selection: any }[]) {
        models = models.filter(i => !(i as any as LocalProduct<IProductDataV2>).isSoldOut);
        const stockFilter = this.filtersMap[IN_STOCK_FILTER_ID];
        let applyStockFilter = false;
        if (stockFilter) {
            let selectionOverride = overrides?.find(i => i.filter === stockFilter)?.selection;
            if (selectionOverride !== false) {
                if (selectionOverride && !Array.isArray(selectionOverride)) {
                    selectionOverride = [selectionOverride];
                }
                if ((selectionOverride || stockFilter.selection || []).includes(EStockOption.inStock)) {
                    applyStockFilter = true;
                }
            }
        }
        // if product is in phase discontinued or we do apply stock checking then we need to check children stock status
        return models.filter(
            model =>
                (!applyStockFilter &&
                    ![EProductPhase.discontinued, EProductPhase.eol].includes(
                        (model as any as LocalProduct<IProductDataV2>).data?.phase as number
                    )) ||
                model.deepStockCheck(selection, true)
        );
    }
}
